import {useCallback, useContext} from "react";
import {TranslationContext} from "@/Utils/TranslationProvider";

export const useTranslation = () => {
    const translations = useContext(TranslationContext);

    const t = useCallback(
        (component, fallback) => {
            if (translations?.translations && Object.keys(translations?.translations).length > 0) {
                return translations?.translations[component] ?? fallback;
            }

            return fallback;
        },
        [translations]
    );

    const prefixLoaded = useCallback(
        (prefix) => {
            if (translations?.translations && Object.keys(translations?.translations).length > 0) {
                return Object.keys(translations?.translations).findIndex((key) => key.startsWith(prefix + ".")) != -1;
            }

            return false;
        },
        [translations]
    );

    const addTranslations = useCallback(
        (newTranslations) => {
            if (translations?.translations && Object.keys(translations?.translations).length > 0) {
                const temp = {};
                newTranslations?.translations?.forEach((translation) => {
                    temp[translation?.component] = translation.text;
                });

                translations?.setTranslations({...translations?.translations, ...temp});
            }
        },
        [translations]
    );

    return {t, translations, prefixLoaded, addTranslations};
};
